import { render, staticRenderFns } from "./CompetentAuthorityLanguageWrapper.vue?vue&type=template&id=86a25cac&"
import script from "./CompetentAuthorityLanguageWrapper.vue?vue&type=script&lang=js&"
export * from "./CompetentAuthorityLanguageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CompetentAuthorityLanguageWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports